import { render, staticRenderFns } from "./IniciadosTrtMultisesion.vue?vue&type=template&id=98fb7f1c&scoped=true"
import script from "./IniciadosTrtMultisesion.vue?vue&type=script&lang=js"
export * from "./IniciadosTrtMultisesion.vue?vue&type=script&lang=js"
import style0 from "./IniciadosTrtMultisesion.vue?vue&type=style&index=0&id=98fb7f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fb7f1c",
  null
  
)

export default component.exports